import { connect } from 'react-redux';

import { selectActivity } from '../actions'
import { addBreadcrumb } from '../../assessments/actions'
import Activities from '../components/Activities'

function mapStateToProps(state) {

    const { selectedActivity  } = state
    return {
      selectedActivity,
      showId: false
    }
  }
  

  const mapDispatchToProps = (dispatch, ownProps) => {
    return {

        addBreadcrumb: (breadcrumb) => { dispatch(addBreadcrumb(breadcrumb))},

        handleActivity: (activity, breadcrumb) => {
          dispatch(selectActivity(activity))
          dispatch(addBreadcrumb(breadcrumb))
        }

        
    }
}  

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Activities)



// WEBPACK FOOTER //
// ./src/activities/containers/Activities.js